import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import PageLayout from '../../../atoms/page-layout';
import CompanyInfoHeader from './company-info-header';
import CompanyInfoPageContent from './company-info-content';
import { useFullPageLoading } from '../../../atoms/full-page-loading/loadingContext';
import { fetchCompanyExperts } from './helpers';
export interface profileElement {
    id: number,
    name: string
}

export interface CompanyInfo {
    id: number,
    name: string
}

const CompanyInfoPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [companyInfo, setCompanyInfo] = useState<CompanyInfo | null>(null);
    const { setLoading } = useFullPageLoading();
    const [data, setData] = useState<profileElement[]>([]);
    const [totalResults, setTotalResults] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const getCompanyInfo = async (rowsPerPage = 50, page = 1) => {
        try {
            const companyData = JSON.parse(atob(decodeURIComponent(searchParams.get("data") || "")));
            setCompanyInfo(companyData);
            const result = await fetchCompanyExperts(companyData, rowsPerPage, page);
            setData(result?.experts);
            setTotalResults(result?.totalResult);
            setTotalPages(result?.totalPages);
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }
    const firstFetch = async () => {
        setLoading(true);
        getCompanyInfo();
    }
    useEffect(() => {
        firstFetch();
    }, [])
    return (
        <PageLayout>
            <CompanyInfoHeader />
            <CompanyInfoPageContent data={data} setData={setData} refetch={getCompanyInfo} companyInfo={companyInfo} totalResults={totalResults} totalPages={totalPages} />


        </PageLayout>
    )
}

export default CompanyInfoPage